import { render, staticRenderFns } from "./ViewSelectedOrder.vue?vue&type=template&id=45a1daf8&scoped=true&"
import script from "./ViewSelectedOrder.vue?vue&type=script&lang=js&"
export * from "./ViewSelectedOrder.vue?vue&type=script&lang=js&"
import style0 from "./ViewSelectedOrder.vue?vue&type=style&index=0&id=45a1daf8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a1daf8",
  null
  
)

export default component.exports